import { LOCALES } from '../locales'

export default {
  [LOCALES.de]: {
    'hello': 'Hallo Welt',
    'edit': '{path} bearbeiten und zum Neuladen speichern'
  }
}
